import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
  headers: {
    'content-type': 'application/json',
    'x-requested-with': 'XMLHttpRequest'
  }
})
